export function getTranslationsUrl(locale: string, cacheBuster?: string): string {
	// temp
	return `https://static.change.org/i18n/production/${locale}.json${cacheBuster ? `?${cacheBuster}` : ''}`;
}
